export function stripNonDigits(phoneNumber: string): string {
  if (!phoneNumber) {
    return '';
  }
  const NotADigitRegexp = /\D/g;
  return phoneNumber.replace(NotADigitRegexp, '');
}
